import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HC_more from 'highcharts/highcharts-more';
import HC_3d from 'highcharts/highcharts-3d';

// Initialize modules
if (typeof Highcharts === 'object') {
  HC_more(Highcharts);
  HC_3d(Highcharts);
}

const PieChart = ({ data = [] }) => {
  // Vibrant color palette
  const colors = [
    '#6366F1', '#F59E42', '#10B981', '#F43F5E', '#FBBF24', '#3B82F6', '#8B5CF6', '#EC4899', '#22D3EE', '#84CC16'
  ];
  // Transform data for Highcharts
  const chartData = data.length
    ? data.map((item, idx) => ({
      name: item.plantname || item.name || 'Unknown',
      y: Number(item.value || item.total || 1).toFixed(2) * 1, // ensure number, 2 decimals
      color: colors[idx % colors.length]
    }))
    : [];



  const options = {
    chart: {
      type: 'pie',
      backgroundColor: 'transparent',
      options3d: {
        enabled: true,
        alpha: 60,
        beta: 0
      },
      animation: {
        duration: 1800,
        easing: 'easeOutBounce',
      },
      style: {
        fontFamily: 'Inter, Segoe UI, Roboto, sans-serif',
      },
      height: 350,
      shadow: true,
    },
    title: {
      text: '',
      style: {
        fontWeight: 'bold',
        fontSize: '22px',
        color: '#0F172A',
        letterSpacing: '0.5px',
      },
      align: 'center',
    },
    tooltip: {
      pointFormat: '<b>{point.percentage:.1f}%</b> <br/>Per Unit: <b>{point.y:.2f}</b>',
      backgroundColor: '#fff',
      borderColor: '#6366F1',
      borderRadius: 10,
      style: {
        color: '#1E293B',
        fontSize: '15px',
        fontWeight: '500',
      },
      animation: true,
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        depth: 50,
        innerSize: '60%',
        borderWidth: 0,
        dataLabels: {
          enabled: true,
          format: '<span style="color:#0F172A;font-weight:700">{point.name}</span><br/><span style="color:#6366F1">{point.y:.2f} perunit</span>',
          style: {
            textOutline: 'none',
            fontWeight: '600',
            fontSize: '15px',
          },
        },
        showInLegend: true,
        animation: {
          duration: 1800,
          easing: 'easeOutBounce',
        },
        shadow: true,
      },
    },
    legend: {
      align: 'center',
      verticalAlign: 'bottom',
      layout: 'horizontal',
      itemStyle: {
        color: '#334155',
        fontWeight: '600',
        fontSize: '15px',
      },
      labelFormatter: function () {
        return this.name + ': ' + this.y.toFixed(2) + ' perunit';
      }
    },
    series: [
      {
        name: 'Per Unit',
        data: chartData,
      },
    ],
    credits: { enabled: false },
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 900,
          },
          chartOptions: {
            chart: {
              height: 150,
            },
            legend: {
              layout: 'center',
              align: 'center',
              verticalAlign: 'center',
            },
          },
        },
      ],
    },
  };

  return (
    <div className="bg-gradient-to-br from-indigo-50 to-white rounded-2xl shadow-2xl px-2 py-4 sm:p-8 flex flex-col items-center justify-center min-h-[250px] sm:min-h-[350px] border border-indigo-100 w-full">
      
      {data.length === 0 ? (
        <div className="text-gray-400 text-base sm:text-lg font-semibold flex flex-col items-center justify-center h-full min-h-[120px]">
          <span>No data available</span>
        </div>
      ) : (
        
        <div className="w-full flex flex-col items-center">
          <div className="w-full overflow-x-auto">
            <div className="min-w-[300px] sm:min-w-0">
              <HighchartsReact highcharts={Highcharts} options={options} />
            </div>
          </div>
          {/* Responsive, attractive table for pie data */}
          <div className="mt-6 w-full overflow-x-auto">
            <table className="min-w-[300px] w-full text-xs sm:text-sm border border-indigo-100 rounded-lg overflow-hidden">
              <thead className="bg-indigo-100">
                <tr>
                  <th className="py-2 px-3 text-left font-semibold text-indigo-700">Plant Name</th>
                  <th className="py-2 px-3 text-left font-semibold text-indigo-700">Per Unit</th>
                </tr>
              </thead>
              <tbody>
                {chartData.map((item, idx) => (
                  <tr key={item.name} className={idx % 2 === 0 ? 'bg-white' : 'bg-indigo-50'}>
                    <td className="py-2 px-3 whitespace-nowrap">{item.name}</td>
                    <td className="py-2 px-3 whitespace-nowrap font-medium text-indigo-700">{item.y.toFixed(2)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default PieChart;
